<script>
import apiEndpoints from "@/services/apiEndpoints";
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";
import sweetAlert from "@/mixins/sweetAlert";

export default {
  name: "ModalListDeliveryLetter",
  mixins: [datetime, sweetAlert],
  components: {
    CommonTableComponent
  },
  data() {
    return {
      data: [],
      scheduleIds: [],
      dataSelected: [],
      isLoading: false,
      headers: [
        {
          text: "受付番号",
        },
        {
          text: "処分事業者",
        },
        {
          text: "処分事業場",
        },
        {
          text: "作業指示名",
        },
        {
          text: "開始時間",
        },
        {
          text: "終了時間",
        },
      ],
      isCheckedAll: false,
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      if (this.scheduleIds.length > 0) {
        const {status, data} = await this.$http.post(apiEndpoints.list_waste_or_service_by_daily_reports, {ids: this.scheduleIds});
        if (status) {
          this.data = data.result;
        }
      }
      this.isLoading = false;
    },
    closeModal() {
      this.$bvModal.hide("list-delivery-letter");
    },
    async openModal(schedules) {
      this.clearSelectedData();
      if (schedules.length > 0) {
        this.scheduleIds = Array.from(new Set(schedules.map(item => item.schedule_id)));
      }
      this.$nextTick(() => this.$bvModal.show("list-delivery-letter"))
    },
    onClickRow(id) {
      const index = this.dataSelected.indexOf(id);
      if (index === -1) {
        this.dataSelected.push(id);
      } else {
        this.dataSelected.splice(index, 1);
      }
    },
    handleCheckboxAllChange(newValue) {
      this.dataSelected = newValue ? this.data.map(item => item.id) : [];
    },
    async onClickPrint() {
      this.isLoading = true;
      const url = apiEndpoints.export_delivery_confirmation_letter;
      const { code, data, headers } = await this.$http.downloadPost(url, {ids: this.dataSelected})

      if (code === 200) {
        const disposition = headers['content-disposition'];
        let filename = '';
        if (disposition.indexOf('filename*=') !== -1) {
          filename = decodeURIComponent(disposition.split('filename*=')[1].replace('utf-8\'\'', ''));
        } else {
          filename = disposition.split(';')[1].split('filename=')[1].split('"')[1];
        }

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      } else {
        this.errorToast(data.message, false, 5000, "top-end");
      }
      this.isLoading = false;
    },
    clearSelectedData() {
      this.isCheckedAll = false;
      this.dataSelected = [];
    },
    formatDateTimeHour(datetime) {
      return this.formatDate(datetime, 'HH:mm')
    },
  },
  watch: {
    dataSelected: {
      immediate: false,
      handler(value) {
        if (this.data.length) {
          this.isCheckedAll = this.$_.isEqual(this.$_.cloneDeep(value).sort(), this.data.map(item => item.id).sort());
        }
      }
    },
  },
}
</script>
<template>
  <div class="d-xl-flex">
    <b-modal
      size="xl"
      id="list-delivery-letter"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
                <tr>
                  <th class="text-center">
                    <b-form-checkbox
                      v-model="isCheckedAll"
                      @change="handleCheckboxAllChange"
                    />
                  </th>
                  <th
                    v-for="(item, index) in headers"
                    :key="index"
                  >
                    {{ item.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in data">
                  <tr class="cursor-pointer" @click="onClickRow(item.id)">
                    <td class="text-center">
                      <b-form-checkbox
                        v-model="dataSelected"
                        :value="item.id"
                      ></b-form-checkbox>
                    </td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.vendor_name_abbreviated }}</td>
                    <td>{{ item.vendor_site_name_abbreviated }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ formatDateTimeHour(item.start_datetime) }}</td>
                    <td>{{ formatDateTimeHour(item.end_datetime) }}</td>
                  </tr>
                </template>
                <template v-if="!data.length">
                  <tr>
                    <td :colspan="headers.length" class="text-center">
                      データなし。
                    </td>
                  </tr>
                </template>
              </tbody>
            </CommonTableComponent>
          </div>
        </b-overlay>
      </b-row>
      <b-row style="margin-top: 10px;">
        <div class="d-flex justify-content-end align-items-center">
          <b-button size="xl" variant="primary" class="me-2" @click="closeModal">{{ this.$lang.button.back }}</b-button>
          <b-button v-if="dataSelected.length" size="xl" variant="primary" class="me-2" @click="onClickPrint()">印刷</b-button>
        </div>
      </b-row>
    </b-modal>
  </div>
</template>